export const EditCard = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
    <circle cx="20" cy="20" r="20" fill="var(--color-bg-primary)" />
    <path
      d="M13.54 27.52C12.93 27.52 12.36 27.31 11.95 26.92C11.43 26.43 11.18 25.69 11.27 24.89L11.64 21.65C11.71 21.04 12.08 20.23 12.51 19.79L20.72 11.1C22.77 8.93 24.91 8.87 27.08 10.92C29.25 12.97 29.31 15.11 27.26 17.28L19.05 25.97C18.63 26.42 17.85 26.84 17.24 26.94L14.02 27.49C13.85 27.5 13.7 27.52 13.54 27.52ZM23.93 10.91C23.16 10.91 22.49 11.39 21.81 12.11L13.6 20.81C13.4 21.02 13.17 21.52 13.13 21.81L12.76 25.05C12.72 25.38 12.8 25.65 12.98 25.82C13.16 25.99 13.43 26.05 13.76 26L16.98 25.45C17.27 25.4 17.75 25.14 17.95 24.93L26.16 16.24C27.4 14.92 27.85 13.7 26.04 12C25.24 11.23 24.55 10.91 23.93 10.91Z"
      fill={strokeColor}
    />
    <path
      d="M25.3404 18.95C25.3204 18.95 25.2904 18.95 25.2704 18.95C22.1504 18.64 19.6404 16.27 19.1604 13.17C19.1004 12.76 19.3804 12.38 19.7904 12.31C20.2004 12.25 20.5804 12.53 20.6504 12.94C21.0304 15.36 22.9904 17.22 25.4304 17.46C25.8404 17.5 26.1404 17.87 26.1004 18.28C26.0504 18.66 25.7204 18.95 25.3404 18.95Z"
      fill={strokeColor}
    />
    <path
      d="M29 30.75H11C10.59 30.75 10.25 30.41 10.25 30C10.25 29.59 10.59 29.25 11 29.25H29C29.41 29.25 29.75 29.59 29.75 30C29.75 30.41 29.41 30.75 29 30.75Z"
      fill={strokeColor}
    />
  </svg>
);
